<template>
    <div>
        <box-tipo :data="data" />
    </div>
</template>

<script>
// Components.
import BoxTipo from './components/Index'

// Mixins.
import { repository, formats } from '@/mixins'

export default {
    components: { BoxTipo },
    computed: {
        validations() {

            return {
                procedimento: {},
            }
        },
    },
    mixins: [repository, formats],
    props: {
        data: { type: Object, required: true },
    }
}
</script>
